import "react-tooltip/dist/react-tooltip.css";
import "leaflet/dist/leaflet.css";
import "react-phone-input-2/lib/style.css";
import "react-quill-new/dist/quill.snow.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";

import "./App/Assets/Styles/App/AppStylesImported.css";

import { AppRouting } from "./_CORE/Routing/AppRouting";
import { AppProviders } from "./_CORE/Contexts/_AppProviders";
import { AppErrorBoundary } from "./_CORE/Contexts/_Auth/_App/_index";
import { AppTemplateResolved } from "./App/WEB/_Templates/AppTemplateResolved";
import { AppConfirmHost } from "./App/WEB/_Templates/_UI/Confirm/AppConfirmHost";
import CelebrationBrandingTestPanel from "./App/WEB/UI_TEST/CelebrationBrandingTestPanel";
import { APP_RUNTIME_LAYOUTS } from "./_CORE/_RuntimeConfig/Runtime/appRuntime.generated";

function App() {
    if (APP_RUNTIME_LAYOUTS.IS_LOGO_TEST_CELEBRATION_DATE === true) {
        return <CelebrationBrandingTestPanel />;
    }

    return (
        <AppErrorBoundary>
            <AppTemplateResolved>
                <AppProviders>
                    <AppRouting />
                    <AppConfirmHost />
                </AppProviders>
            </AppTemplateResolved>
        </AppErrorBoundary>
    );
}

export default App;
